window.$ = window.jQuery = require("jquery");
$(document).ready(function (e) {
    // Facebook
    const facebookShare = function (e) {
        const boxUrl = "https://www.facebook.com/sharer.php?u=" + encodeURIComponent(window.location.href);
        const boxTitle = "Partagez";
        const boxOption =
            "menubar=no, status=no, scrollbars=no, menubar=no, width=400, height=400";
        window.open(boxUrl, boxTitle, boxOption);
    };
    const facebookBtnResponsive = document.querySelector(".facebook-share-resp");
    const facebookBtn = document.querySelector(".facebook-share");

    if (facebookBtn) {
        facebookBtn.addEventListener("click", facebookShare);
    } else if (facebookBtnResponsive) {
        facebookBtnResponsive.addEventListener("click", facebookShare);
    }
    // linkedin
    const linkedinShare = function (e) {
        const boxUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' +
            encodeURIComponent(window.location.href);
        const boxTitle = "Partagez";
        const boxOption =
            "menubar=no, status=no, scrollbars=no, menubar=no, width=400, height=400";
        window.open(boxUrl, boxTitle, boxOption);
    };
    const linkedinBtnResponsive = document.querySelector(".linkedin-share-resp");
    const linkedinBtn = document.querySelector(".linkedin-share");

    if (linkedinBtn) {
        linkedinBtn.addEventListener("click", linkedinShare);
    } else if (linkedinBtnResponsive) {
        linkedinBtnResponsive.addEventListener("click", linkedinShare);
    }
});